import { ElementViewTemplate, html } from "@microsoft/fast-element";
import { NatGenCard } from "./card";

export function cardTemplate<T extends NatGenCard>(): ElementViewTemplate<T> {
    return html`
        <slot></slot>
    `;
}
